export const CONNECTION_REQUIRES_REAUTH_ERROR = 'Connection requires reauthentication';

export type IntegrationConnectionState = 'connected' | 'needs_reauth' | 'disconnected';

export type IntegrationAuthStatusProvider =
  | 'slack'
  | 'linear'
  | 'jira'
  | 'asana'
  | 'notion'
  | 'confluence';

export type IntegrationAuthStatuses = Partial<
  Record<IntegrationAuthStatusProvider, IntegrationConnectionState>
>;

export type IntegrationAuthErrorFields = {
  authErrorType: string | null;
  authFailedAt: Date | string | null;
};

export function getIntegrationConnectionState(
  connection: Partial<IntegrationAuthErrorFields> | null | undefined,
): IntegrationConnectionState {
  if (!connection) {
    return 'disconnected';
  }

  return connection.authFailedAt ? 'needs_reauth' : 'connected';
}

export function isIntegrationAuthHealthy(
  connection: Partial<IntegrationAuthErrorFields> | null | undefined,
): boolean {
  return getIntegrationConnectionState(connection) === 'connected';
}

export function getIntegrationAuthErrorMessage(): string {
  return CONNECTION_REQUIRES_REAUTH_ERROR;
}
